import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "@fontsource-variable/bricolage-grotesque/wght.css";
import "@fontsource-variable/figtree/wght.css";
import { App } from "./App";
import "./styles.css";
import "./styles/features.css";
import "./styles/admin-extra.css";
import "./styles/community.css";
import "./styles/staff.css";
import "./styles/portal.css";
import "./styles/site.css";
import "./styles/site-pages.css";
import "./styles/store-site.css";
import "./ServerAudit.css";

createRoot(document.getElementById("root")!).render(<StrictMode><BrowserRouter><App /></BrowserRouter></StrictMode>);
